import styled from 'styled-components/macro';

import { LogoWrapperBase as LogoWrapper } from 'components/Header/HeaderPanel/HeaderPanel';

export const PageContent = styled('div')`
  text-align: center;
  display: flex;
  flex-flow: column;
  height: 100%;
  color: ${({ theme }): string => theme.NightBlue};
`;

export const LogoContainer = styled(LogoWrapper)`
  margin: 0 !important;
  padding: ${({ theme }): string => theme.spacing.large} 0;
  background-color: ${({ theme }): string => theme.AccentGreen};
  line-height: 1;

  svg {
    color: ${({ theme }): string => theme.LightNightBlue};
    height: 1.6875em;
  }

  @media screen and (min-width: 40em) {
    padding: ${({ theme }): string => theme.spacing.xxlarge} 0;

    svg {
      height: 3em;
    }
  }
`;

export const Content = styled('main')`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #f9f9f9;

  @media screen and (min-width: 40em) {
    justify-content: initial;
    padding-top: 10.5em;
  }

  h2 {
    color: #000d37;
    font-size: 1.25em;
    margin-bottom: ${({ theme }): string => theme.spacing.xlarge};
  }
`;

export const LinkToMail = styled('a')`
  color: ${({ theme }): string => theme.NightBlue};
`;

export const Text = styled('p')`
  margin: 0 auto ${({ theme }): string => `${theme.spacing.xlarge}`};
  width: 18.5em;
  line-height: 1.44;
`;

export const Button = styled('button')`
  width: 170px;
  height: 50px;
  margin: 0 auto;
  background-color: ${({ theme }): string => theme.AccentGreen};
  color: ${({ theme }): string => theme.White};
  font-weight: bold;
  cursor: pointer;
`;

export const Footer = styled('footer')`
  background-color: #ecf0f4;
  padding: ${({ theme }): string => theme.spacing.large} 0;
`;
